var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("Webheader.injection_unit") } },
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { attrs: { slot: "pageContent" }, slot: "pageContent" },
          [
            _c(
              "b-container",
              { attrs: { fluid: "" } },
              [
                _c(
                  "form-accordion",
                  {
                    attrs: {
                      toggleActive: false,
                      title: _vm.$t("tracking.general_information"),
                      isTitleUpperCase: false,
                    },
                  },
                  [
                    _c(
                      "b-row",
                      {
                        staticClass:
                          "d-flex justify-content-center align-items-center",
                      },
                      [
                        _c(
                          "b-col",
                          { staticClass: "form-group", attrs: { sm: "6" } },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("tracking.please_enter_iban_to_verify")
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("form-write-group-label-input", {
                              attrs: {
                                isMandatory: "",
                                inputLabel:
                                  _vm.$t("tracking.iban") +
                                  " " +
                                  _vm.$t("tracking.to_check"),
                                descLabel: _vm.$t("tracking.iban_description"),
                                placeholderValue: _vm.$t("tracking.iban"),
                              },
                              model: {
                                value: _vm.form.iban,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "iban", $$v)
                                },
                                expression: "form.iban",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { staticClass: "form-group", attrs: { sm: "6" } },
                          [
                            _c("br"),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _vm.verifierIBAN(_vm.form.iban) &&
                            _vm.form.iban != "" &&
                            _vm.corporateIdentifierTypesMatch
                              ? _c("form-write-group-label-input", {
                                  attrs: {
                                    inputLabel: _vm.$t("tracking.reference"),
                                    placeholderValue:
                                      _vm.$t("tracking.reference"),
                                  },
                                  model: {
                                    value: _vm.form.reference,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "reference", $$v)
                                    },
                                    expression: "form.reference",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.ibanFind
                  ? _c(
                      "form-accordion",
                      {
                        attrs: {
                          toggleActive: true,
                          title: _vm.$t(
                            "tracking.information_retrieved_from_iban"
                          ),
                          isTitleUpperCase: false,
                        },
                      },
                      [
                        _c(
                          "b-row",
                          {
                            staticClass:
                              "d-flex justify-content-center align-items-start",
                          },
                          [
                            _c(
                              "b-col",
                              { staticClass: "form-group", attrs: { sm: "4" } },
                              [
                                _c("div", { staticClass: "table-responsive" }, [
                                  _c(
                                    "table",
                                    {
                                      staticClass:
                                        "table table-bordered text-center",
                                      staticStyle: { height: "270px" },
                                    },
                                    [
                                      _c("thead", [
                                        _c("tr", [
                                          _c(
                                            "th",
                                            {
                                              staticClass:
                                                "text-light align-middle",
                                              staticStyle: {
                                                "background-color":
                                                  "#404040 !important",
                                              },
                                              attrs: { colspan: "2" },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("tracking.valid_iban")
                                                )
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("tbody", [
                                        _c(
                                          "tr",
                                          {
                                            staticStyle: {
                                              "background-color": "#F9F9F9",
                                            },
                                          },
                                          [
                                            _c(
                                              "td",
                                              { staticClass: "align-middle" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "tracking.iban_format_verification"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "align-middle" },
                                              [
                                                _vm.format == "$Match"
                                                  ? _c("i", {
                                                      staticClass:
                                                        "fa-solid fa-check text-success",
                                                    })
                                                  : _c("i", {
                                                      staticClass:
                                                        "fa-solid fa-xmark text-danger",
                                                    }),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "tr",
                                          {
                                            staticStyle: {
                                              "background-color": "#F9F9F9",
                                            },
                                          },
                                          [
                                            _c(
                                              "td",
                                              { staticClass: "align-middle" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "tracking.account_key_verification"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "align-middle" },
                                              [
                                                _vm.keyIban == "$Match"
                                                  ? _c("i", {
                                                      staticClass:
                                                        "fa-solid fa-check text-success",
                                                    })
                                                  : _c("i", {
                                                      staticClass:
                                                        "fa-solid fa-xmark text-danger",
                                                    }),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "tr",
                                          {
                                            staticStyle: {
                                              "background-color": "#F9F9F9",
                                            },
                                          },
                                          [
                                            _c(
                                              "td",
                                              { staticClass: "align-middle" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "tracking.iban_key_verification"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "align-middle" },
                                              [
                                                _vm.keyBBAN == "$Match"
                                                  ? _c("i", {
                                                      staticClass:
                                                        "fa-solid fa-check text-success",
                                                    })
                                                  : _c("i", {
                                                      staticClass:
                                                        "fa-solid fa-xmark text-danger",
                                                    }),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c(
                                            "td",
                                            { staticClass: "align-middle" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "tracking.bank_reachable"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "align-middle" },
                                            [
                                              _vm.corporateIdentifierTypesMatch
                                                ? _c("i", {
                                                    staticClass:
                                                      "fa-solid fa-check text-success",
                                                  })
                                                : _c("i", {
                                                    staticClass:
                                                      "fa-solid fa-xmark text-danger",
                                                  }),
                                            ]
                                          ),
                                        ]),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { staticClass: "form-group", attrs: { sm: "4" } },
                              [
                                _c("div", { staticClass: "table-responsive" }, [
                                  _c(
                                    "table",
                                    {
                                      staticClass:
                                        "table table-bordered text-center",
                                      staticStyle: { height: "270px" },
                                    },
                                    [
                                      _c("thead", [
                                        _c("tr", [
                                          _c(
                                            "th",
                                            {
                                              staticClass:
                                                "text-light align-middle",
                                              staticStyle: {
                                                "background-color":
                                                  "#404040 !important",
                                              },
                                              attrs: { colspan: "2" },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "tracking.bank_domiciliation"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("tbody", [
                                        _c(
                                          "tr",
                                          {
                                            staticStyle: {
                                              "background-color": "#F9F9F9",
                                            },
                                          },
                                          [
                                            _c(
                                              "td",
                                              { staticClass: "align-middle" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "tracking.institution_name"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.institutionName !== "" &&
                                            _vm.institutionName !== "$NotFound"
                                              ? _c(
                                                  "td",
                                                  {
                                                    staticClass: "align-middle",
                                                    attrs: {
                                                      id: "InstitutionName",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.institutionName
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "td",
                                                  {
                                                    staticClass: "align-middle",
                                                  },
                                                  [_vm._v("-")]
                                                ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "tr",
                                          {
                                            staticStyle: {
                                              "background-color": "#F9F9F9",
                                            },
                                          },
                                          [
                                            _c(
                                              "td",
                                              { staticClass: "align-middle" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "tracking.branch_information"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.branchInformation !== "" &&
                                            _vm.branchInformation !==
                                              "$NotFound"
                                              ? _c(
                                                  "td",
                                                  {
                                                    staticClass: "align-middle",
                                                    attrs: {
                                                      id: "BranchInformation",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.branchInformation
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "td",
                                                  {
                                                    staticClass: "align-middle",
                                                  },
                                                  [_vm._v("-")]
                                                ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "tr",
                                          {
                                            staticStyle: {
                                              "background-color": "#F9F9F9",
                                            },
                                          },
                                          [
                                            _c(
                                              "td",
                                              { staticClass: "align-middle" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "tracking.address_line_1"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.address1 !== "" &&
                                            _vm.address1 !== "$NotFound"
                                              ? _c(
                                                  "td",
                                                  {
                                                    staticClass: "align-middle",
                                                    attrs: {
                                                      id: "StreetAddress1",
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(_vm.address1))]
                                                )
                                              : _c(
                                                  "td",
                                                  {
                                                    staticClass: "align-middle",
                                                  },
                                                  [_vm._v("-")]
                                                ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.address2 !== "" &&
                                        _vm.address2 !== "$NotFound"
                                          ? _c(
                                              "tr",
                                              {
                                                staticStyle: {
                                                  "background-color": "#F9F9F9",
                                                },
                                              },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "align-middle",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "tracking.address_line_2"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "align-middle",
                                                    attrs: {
                                                      id: "StreetAddress2",
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(_vm.address2))]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.address3 !== "" &&
                                        _vm.address3 !== "$NotFound"
                                          ? _c(
                                              "tr",
                                              {
                                                staticStyle: {
                                                  "background-color": "#F9F9F9",
                                                },
                                              },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "align-middle",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "tracking.address_line_3"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "align-middle",
                                                    attrs: {
                                                      id: "StreetAddress3",
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(_vm.address3))]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.address4 !== "" &&
                                        _vm.address4 !== "$NotFound"
                                          ? _c(
                                              "tr",
                                              {
                                                staticStyle: {
                                                  "background-color": "#F9F9F9",
                                                },
                                              },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "align-middle",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "tracking.address_line_4"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "align-middle",
                                                    attrs: {
                                                      id: "StreetAddress4",
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(_vm.address4))]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "tr",
                                          {
                                            staticStyle: {
                                              "background-color": "#F9F9F9",
                                            },
                                          },
                                          [
                                            _c(
                                              "td",
                                              { staticClass: "align-middle" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "tracking.zip_and_city"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            (_vm.zipCode !== "" &&
                                              _vm.zipCode !== "$NotFound") ||
                                            (_vm.city !== "" &&
                                              _vm.city !== "$NotFound")
                                              ? _c(
                                                  "td",
                                                  {
                                                    staticClass: "align-middle",
                                                    attrs: {
                                                      id: "ZipCodeCity",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          id: "ZipCode",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(_vm.zipCode)
                                                        ),
                                                      ]
                                                    ),
                                                    _c("span", [_vm._v(" ")]),
                                                    _c(
                                                      "span",
                                                      { attrs: { id: "City" } },
                                                      [_vm._v(_vm._s(_vm.city))]
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "td",
                                                  {
                                                    staticClass: "align-middle",
                                                  },
                                                  [_vm._v("-")]
                                                ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.Cps !== "" &&
                                        _vm.Cps !== "$NotFound"
                                          ? _c(
                                              "tr",
                                              {
                                                staticStyle: {
                                                  "background-color": "#F9F9F9",
                                                },
                                              },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "align-middle",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("tracking.cps")
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "align-middle",
                                                    attrs: { id: "Cps" },
                                                  },
                                                  [_vm._v(_vm._s(_vm.Cps))]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "tr",
                                          {
                                            staticStyle: {
                                              "background-color": "#F9F9F9",
                                            },
                                          },
                                          [
                                            _c(
                                              "td",
                                              { staticClass: "align-middle" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "tracking.country_and_iso"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            (_vm.country !== "" &&
                                              _vm.country !== "$NotFound") ||
                                            (_vm.ISOCountryCode !== "" &&
                                              _vm.ISOCountryCode !==
                                                "$NotFound")
                                              ? _c(
                                                  "td",
                                                  {
                                                    staticClass: "align-middle",
                                                    attrs: {
                                                      id: "CountryNameAndIso",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          id: "CountryName",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(_vm.country)
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.ISOCountryCode !==
                                                    "$NotFound"
                                                      ? _c("span", [
                                                          _vm._v("("),
                                                          _c(
                                                            "span",
                                                            {
                                                              attrs: {
                                                                id: "IsoCountryCode",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.ISOCountryCode
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(")"),
                                                        ])
                                                      : _vm._e(),
                                                  ]
                                                )
                                              : _c(
                                                  "td",
                                                  {
                                                    staticClass: "align-middle",
                                                  },
                                                  [_vm._v("-")]
                                                ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { staticClass: "form-group", attrs: { sm: "4" } },
                              [
                                _c("div", { staticClass: "table-responsive" }, [
                                  _c(
                                    "table",
                                    {
                                      staticClass:
                                        "table table-bordered text-center",
                                      staticStyle: { height: "270px" },
                                    },
                                    [
                                      _c("thead", [
                                        _c("tr", [
                                          _c(
                                            "th",
                                            {
                                              staticClass:
                                                "text-light align-middle",
                                              staticStyle: {
                                                "background-color":
                                                  "#404040 !important",
                                              },
                                              attrs: { colspan: "2" },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "tracking.iban_composition"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("tbody", [
                                        _c(
                                          "tr",
                                          {
                                            staticStyle: {
                                              "background-color": "#F9F9F9",
                                            },
                                          },
                                          [
                                            _c(
                                              "td",
                                              { staticClass: "align-middle" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("tracking.bank_code")
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "align-middle" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.IDBank === "$NotFound"
                                                      ? "-"
                                                      : _vm.IDBank
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "tr",
                                          {
                                            staticStyle: {
                                              "background-color": "#F9F9F9",
                                            },
                                          },
                                          [
                                            _c(
                                              "td",
                                              { staticClass: "align-middle" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "tracking.branch_code"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "align-middle" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.IDBranch === "$NotFound"
                                                      ? "-"
                                                      : _vm.IDBranch
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "tr",
                                          {
                                            staticStyle: {
                                              "background-color": "#F9F9F9",
                                            },
                                          },
                                          [
                                            _c(
                                              "td",
                                              { staticClass: "align-middle" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "tracking.account_number"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "align-middle" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.accountNumber ===
                                                      "$NotFound"
                                                      ? "-"
                                                      : _vm.accountNumber
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c(
                                            "td",
                                            { staticClass: "align-middle" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("tracking.bic"))
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "align-middle" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.parentBic === "$NotFound"
                                                    ? "-"
                                                    : _vm.parentBic
                                                )
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.verifierIBAN(_vm.form.iban) &&
                _vm.form.iban !== "" &&
                _vm.corporateIdentifierTypesMatch
                  ? _c(
                      "form-accordion",
                      {
                        attrs: {
                          toggleActive: false,
                          title: _vm.$t("tracking.data_to_check"),
                          isTitleUpperCase: false,
                        },
                      },
                      [
                        _c(
                          "b-row",
                          {
                            staticClass:
                              "d-flex justify-content-center align-items-center",
                          },
                          [
                            _c(
                              "b-col",
                              { staticClass: "form-group", attrs: { sm: "6" } },
                              [
                                _c(
                                  "label",
                                  { attrs: { for: "identifier-type" } },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$t("tracking.type_identifier")
                                        )
                                    ),
                                    _c("span", { staticClass: "color-red" }, [
                                      _vm._v(" * "),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.form.entrepriseIdentifierType,
                                        expression:
                                          "form.entrepriseIdentifierType",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      id: "identifier-type",
                                      required:
                                        _vm.verifierIBAN(_vm.form.iban) &&
                                        _vm.form.iban !== "",
                                      disabled:
                                        !_vm.verifierIBAN(_vm.form.iban) ||
                                        _vm.form.iban === "",
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.$set(
                                          _vm.form,
                                          "entrepriseIdentifierType",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("option", { attrs: { value: "" } }, [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("common.nme")) + " "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(
                                      Object.keys(this.typeList).filter(
                                        (elem) => !_vm.typeList[elem]
                                      ),
                                      function (type) {
                                        return _c(
                                          "option",
                                          {
                                            key: type,
                                            domProps: { value: type },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "tracking.select.identifiers." +
                                                      type +
                                                      ".label"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { staticClass: "form-group", attrs: { sm: "6" } },
                              [
                                _c("form-write-group-label-input", {
                                  attrs: {
                                    isMandatory: "",
                                    disabled:
                                      !_vm.verifierIBAN(_vm.form.iban) ||
                                      _vm.form.iban == "",
                                    inputLabel: _vm.$t("tracking.identifier"),
                                    placeholderValue: _vm.$t(
                                      "tracking.identifier"
                                    ),
                                  },
                                  model: {
                                    value: _vm.form.entrepriseIdentifierName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "entrepriseIdentifierName",
                                        $$v
                                      )
                                    },
                                    expression: "form.entrepriseIdentifierName",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("b-col", {
                              staticClass: "form-group",
                              attrs: { sm: "6" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "b-row",
                  { staticClass: "accordionForm mt-3 justify-content-end" },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "4", lg: "3", xl: "2" } },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "responsive-button",
                            attrs: {
                              variant: "primary",
                              disabled:
                                !_vm.validateForm(false) || _vm.activateSpinner,
                            },
                            on: { click: _vm.addTracking },
                          },
                          [
                            _c("i", { staticClass: "fa-light fa-save" }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("common.send_verification_request")
                                )
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }